import mitt from 'mitt';
import appStore from './app.store.js';

export const appEvents = mitt();

export const toggleFullscreen = (value) => {
    appEvents.emit('toggleFullscreen', value);
}

export const toggleGesture = (value) => {
    saveCurrentDisableGesture(value);
    appEvents.emit('toggleGesture', value);
}

export const saveCurrentDisableGesture = (value) => {
    appStore.state.disableGesture = value;
    localStorage.setItem('disableGesture', value);
}

export const loadCurrentDisableGesture = () => {
    const disableGesture = localStorage.getItem('disableGesture');
    appEvents.emit('currentDisableGesture', disableGesture);
    return disableGesture;
}

export const openSubscriptionModal = () => {
    appEvents.emit('openSubscriptionModal');
}

export const closeSubscriptionModal = () => {
    appEvents.emit('closeSubscriptionModal');
}

export const reloadProfile = () => {
    appEvents.emit('reloadProfile');
}

